function Pagination({ page, totalCount, limit, loading, onPrev, onNext }) {
  const totalPages = Math.ceil(totalCount / limit) || 1;

  return (
    <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
      <button
        className="btn btn-primary"
        disabled={page <= 1}
        onClick={onPrev}
      >
        Previous Page
      </button>

      <div className="d-flex align-items-center">
        {loading ? (
          <span className="me-2">Loading...</span>
        ) : (
          <span className="me-2">
            {(limit * (page - 1)) + 1}-{Math.min(limit * page, totalCount)} / {totalCount}
          </span>
        )}
      </div>

      <button
        className="btn btn-primary"
        disabled={page >= totalPages}
        onClick={onNext}
      >
        Next Page
      </button>
    </div>
  );
}

export default Pagination;
